export default "__VITE_ASSET__GKMr0WsX__"